import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {AppService} from '../../../app.service';
import {Constants} from '../../../shared/utils/constants';
import {LightboxComponent} from '../../../shared/components/lightbox/lightbox.component';
import {forkJoin} from 'rxjs';
import {KycService} from '../kyc.service';
import {KYCModel} from '../../../models/cms.model';
import {Permission} from '../../../models/permission.model';
declare var $: any;

@Component({
  selector: 'fx-kyc-list',
  templateUrl: './kyc-list.component.html',
  styleUrls: ['./kyc-list.component.sass']
})
export class KycListComponent implements OnInit, AfterViewInit {
  @ViewChild('lightbox') lightbox: LightboxComponent;
  @Input() permission: Permission;
  condition: any = {
    keyword: '',
    kycCode: '',
    orderBy: 'country'
  };
  sort: any = {
    country: 'desc',
  };
  pageInfo: any = {
    pageIndex: 1,
    pageSize: 100,
    totalRecord: 0,
    pageManual: 1,
  };
  listKycs = [];
  listKYCStatus = Object.entries(Constants.KYC_STATUS);
  kycDetail = new KYCModel();
  countries = [];
  isEdit = true;
  currentIndexEdit = null;
  constructor(
    private service: KycService,
    private appService: AppService
  ) {
    this.countries = Constants.COUNTRIES.map((c) => {
      return { label: c.name, value: c.code };
    });
  }

  ngOnInit(): void {
    this.getListKyc();
  }
  navigateTo(element: string): void {
    const scrollElement = document.querySelector('#' + element);
    if (scrollElement){
      scrollElement.scrollIntoView({ behavior: 'smooth' });
    }
  }

  onKeyup(evt: KeyboardEvent): void {
    if (evt.keyCode === 13) {
      this.searchKyc();
    }
  }
  searchKyc(): void {
    this.pageInfo.pageIndex = 1;
    this.getListKyc();
  }
  getListKyc(): void {
    const params = {
      q: (this.condition.keyword)
        ? encodeURIComponent((this.condition.keyword).trim())
        : this.condition.keyword.trim(),
      order_by: this.condition.orderBy,
      order_type: this.condition.order,
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize,
      code: +(this.condition.kycCode)
    };
    if (!this.condition.kycCode) {
      delete params['code'];
    }
    this.service.getKYC(params)
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.listKycs = res.data;
          this.pageInfo.totalRecord = res.paging.total;
        }
      });
  }
  getLabelStatus(status): string {
    switch (status) {
      case 0: {
        return 'pending';
      }
      case 1: {
        return 'verify';
      }
      case 2: {
        return 'reject';
      }
      default: {
        return '';
      }
    }
  }
  sorting(column: string): void {
    this.sort[column] = this.sort[column] === 'desc' ? 'asc' : 'desc';
    this.condition.orderBy = column;
    this.condition.order = this.sort[column];
    this.getListKyc();
  }

  onChangeKycProcess(vType, id, action, index): void {
    this.appService
      .confirm({
        title: `Are you sure that you want to ${this.getLabelStatus(action)} KYC?`,
        icon: 'fa fa-question-circle',
        ok: 'Ok',
        cancel: 'Cancel',
      })
      .subscribe((res) => {
        if (res.result) {
          const body = {
            user_id: +(id),
            type: vType,
            status: action
          };
          this.service
            .updateKYCStatus(body)
            .subscribe((data: any) => {
              if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
                this.appService.showSuccess(this.getLabelStatus(action) + ' Successful!'
                );
                const keyParam = (vType === 'id_status')
                  ? 'idStatus' : (vType === 'selfie_status')
                    ? 'handStatus' : 'addressStatus';
                this.listKycs[index][keyParam] = action;
                this.getListKyc();
              } else {
                this.appService.showError(
                  data.message ||
                  this.getLabelStatus(action) + ' Fail!'
                );
              }
            });
        }
      });
  }
  onEdit(item): void {
    if (item) {
      this.isEdit = true;
      this.currentIndexEdit = item.id;
    } else {
      this.onReset();
    }
  }
  onSave(item): void {
    const body = {
      user_id: item.id,
      comment: item.comment,
    };
    this.updateKycComment(body);
  }
  onReset(): void {
    this.isEdit = false;
    this.currentIndexEdit = null;
    this.getListKyc();
  }
  updateKycComment(body: any): void {
    this.service.updateKycComment(body)
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.appService.showSuccess('Update comment success');
        }
        this.onReset();
      });
  }
  getAllImageKyc(item: any): void {
    const listKyc = ['idUrl', 'idBackUrl', 'handUrl', 'addressUrl','addressBackUrl'];
    const listBase = [];
    const joinApi = [[],[]];
    listKyc.map(v => {
      if (item[v]) {
        joinApi[0].push(this.service.getImage({url: item[v]}));
        joinApi[1].push(this.mappingLabelKyc(v));
      }
    });
    forkJoin(joinApi[0]).subscribe(res => {
      joinApi[1].map((v, index) => {
        listBase.push(
          {
            id: index,
            title: v,
            image: res[index]
          }
        );
      });
      //sorting the listBase array
      listBase.sort((a, b) => {
        return a.id - b.id;
      });
      this.lightbox.openModal(listBase);
    });
  }

  mappingLabelKyc(type): string {
    switch (type) {
      case 'idUrl': {
        return 'ID Front';
      }
      case 'idBackUrl': {
        return 'ID Back';
      }
      case 'handUrl': {
        return 'ID on Hand';
      }
      case 'addressUrl': {
        return 'Address Front';
      }
      case 'addressBackUrl': {
        return 'Address Back';
      }
      default: {
        return '';
      }
    }
  }
  /*openImages(item: any, id): void {
    const keyData = id + 'Url';
    const option = {
      url: item[keyData]
    }
    const listBase = [];
    if (id === 'id' && item[(id + 'BackUrl')]) {
      const keyBackData = id + 'BackUrl';
      const optionBack = {
        url: item[keyBackData]
      }
      forkJoin([
        this.service.getImage(option),
        this.service.getImage(optionBack)
      ]).subscribe(response => {
        if (response[0].status === Constants.RESPONSE_STATUS.SUCCESS) {
          listBase.push(response[0].data.base64_data);
        }
        if (response[1].status === Constants.RESPONSE_STATUS.SUCCESS) {
          listBase.push(response[1].data.base64_data);
        }
        this.lightbox.openModal(listBase);
      });
    } else {
      this.service.getImage(option)
        .subscribe(res => {
          if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
            listBase.push(res.data.base64_data);
            this.lightbox.openModal(listBase);
          }
        });
    }
  }*/

  pageChanged(page: number): void {
    this.pageInfo.pageIndex = page;
    this.pageInfo.pageManual = page;
    this.getListKyc();
  }
  onKeyupPage(evt: KeyboardEvent): void {
    if (evt.keyCode === 13) {
      this.pageInfo.pageIndex = this.pageInfo.pageManual;
      this.getListKyc();
    }
  }

  getLabelStatusKyc(status): string {
    switch (status) {
      case -1:
        return '<span class="text-muted">Unuploaded</span>';
      case 0:
        return '<span class="text-primary">Uploaded</span>';
      case 1:
        return '<span class="text-green">Verified</span>';
      case 2:
        return '<span class="text-red">Rejected</span>';
    }
  }
  getKycDetail(item): void {
    this.kycDetail = item;
  }
  getCountryNameByCode(code): string {
    return this.countries.find(v => v.value === code)?.label || '';
  }

  ngAfterViewInit(): void {
    $('#modalLightBox').on('hide.bs.modal', () => {
      $('.zoomContainer').remove();
    });
  }
}
